const LABELS = {
  operational: {
    healthy: "Healthy",
    online: "Online",
    degraded: "Degraded",
    stale: "Stale",
    offline: "Offline",
    unknown: "Unknown",
  },
  firmware: {
    current: "Current",
    "update-available": "Update available",
    unassigned: "Unassigned",
    incompatible: "Incompatible",
    unknown: "Unknown",
  },
  ota: {
    validated: "Validated",
    "in-progress": "Updating",
    failed: "Failed",
    "not-tested": "Not yet OTA-tested",
    unknown: "Unknown",
  },
  configuration: {
    configured: "Configured",
    unmapped: "Unmapped",
    incomplete: "Incomplete",
  },
};

function display(kind, value) {
  return LABELS[kind][value] || String(value || "Unknown").replaceAll("_", " ");
}

export function deviceStatusDimensions(device) {
  const firmwareLabel = display("firmware", device.firmwareStatus);
  return [
    {
      key: "operational",
      label: "Operational",
      value: device.operationalStatus || "unknown",
      display: display("operational", device.operationalStatus),
      title: "Based on recent server-observed valid presence samples.",
    },
    {
      key: "firmware",
      label: "Firmware",
      value: device.firmwareStatus || "unknown",
      display: device.firmwareStatus === "current" && device.firmwareSource === "bootstrap"
        ? `${firmwareLabel} (bootstrap)`
        : firmwareLabel,
      title: "Compares the reported release with the compatible assignment.",
    },
    {
      key: "ota",
      label: "OTA validation",
      value: device.otaValidationStatus || "unknown",
      display: display("ota", device.otaValidationStatus),
      title: device.otaValidationStatus === "not-tested"
        ? "Expected when the current image was provisioned directly and has not completed an OTA pending-image health confirmation."
        : "Rollback-protected evidence from the OTA lifecycle.",
    },
    {
      key: "configuration",
      label: "Configuration",
      value: device.configurationStatus || "incomplete",
      display: display("configuration", device.configurationStatus),
      title: "Checks required registry metadata and House Map room assignment.",
    },
  ];
}